import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getLanguages = (token, id = "") => {
    return fetch(`${apiUrl}languages/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getLanguages